import { generate } from "@pdfme/generator"
import templateHandler from "./reportTemplateHandler"

/// Visit https://pdfme.com/template-design to generate new base templates
export default {
    async generateReport(templateOptions, scenario, data, images) {
      let template = this.prepareTemplate(scenario, images, templateOptions.plotCount)
      const inputs = this.prepareInputs(scenario, data, images, templateOptions.plotCount)
      const pdf = await generate({ template, inputs });

      // Node.js
      // fs.writeFileSync(path.join(__dirname, 'test.pdf'), pdf);
    
      // Browser
      const blob = new Blob([pdf.buffer], { type: 'application/pdf' });
      window.open(URL.createObjectURL(blob));
    },
    prepareTemplate(scenario, images, plotCount) {
      /// 1. Select base PDF
      /// 2. Add base info (organization, date...) and first plot
      /// 3. Add scenario-specific info
      /// 4. Add a page every two plots
      let imagesSizes = this.processImages(images, plotCount)
      let basePdf = templateHandler.getTemplateBasePdf(scenario, plotCount)
      let projectData = 
      {
        "date": {
          "type": "text",
          "position": {
            "x": 185,
            "y": 17.5
          },
          "width": 19.12,
          "height": 5.41,
          "alignment": "center",
          "fontSize": 10,
          "characterSpacing": 0,
          "lineHeight": 1,
          "fontColor": "#ffffff"
        },
        "organisation": {
          "type": "text",
          "position": {
            "x": 12,
            "y": 12
          },
          "width": 86.86,
          "height": 7,
          "alignment": "left",
          "fontSize": 13,
          "characterSpacing": 0,
          "lineHeight": 1,
          "fontColor": "#ffffff"
        },
        "user": {
          "type": "text",
          "position": {
            "x": 132.46,
            "y": 17.5
          },
          "width": 49.46,
          "height": 3.72,
          "fontSize": 10,
          "alignment": "center",
          "fontColor": "#ffffff"
        },
        "title": {
          "type": "text",
          "position": {
            "x": 48.75,
            "y": 33
          },
          "width": 114.25,
          "height": 6.99,
          "alignment": "left",
          "fontSize": 14,
          "characterSpacing": 0,
          "lineHeight": 1,
          "fontColor": "#ff1f40"
        },
        "summary": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 47
          },
          "width": 103.79,
          "height": 5.68,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "project_type": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 59.09
          },
          "width": 103,
          "height": 7,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "study_phase": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 70
          },
          "width": 103,
          "height": 7,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "external_identifier": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 80.87
          },
          "width": 103,
          "height": 7,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "primary_investigator": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 91
          },
          "width": 103,
          "height": 7,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "outcome": {
          "type": "text",
          "position": {
            "x": 75,
            "y": 103
          },
          "width": 103,
          "height": 7,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "description_long": {
          "type": "text",
          "position": {
            "x": 21.17,
            "y": 121.17
          },
          "width": 167.82,
          "height": 40.87,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1.1
        },
        "study_design": {
          "type": "text",
          "position": {
            "x": 21.17,
            "y": 180.4
          },
          "width": 167.82,
          "height": 23.66,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1
        },
        "elegibility_criteria": {
          "type": "text",
          "position": {
            "x": 21.17,
            "y": 216.57
          },
          "width": 168.08,
          "height": 37.43,
          "alignment": "left",
          "fontSize": 9,
          "characterSpacing": 0,
          "lineHeight": 1.1
        }
      }
      let baseData = 
          {
            "title": {
              "type": "text",
              "position": {
                "x": 48.75,
                "y": 33
              },
              "width": 114.25,
              "height": 6.99,
              "alignment": "left",
              "fontSize": 14,
              "characterSpacing": 0,
              "lineHeight": 1,
              "fontColor": "#ff1f40"
            },
            "description": {
              "type": "text",
              "position": {
                "x": 20.96,
                "y": 42.66
              },
              "width": 166.23,
              "height": 10.96,
              "alignment": "left",
              "fontSize": 9,
              "characterSpacing": 0,
              "lineHeight": 1
            },
            "plot0": {
              "type": "image",
              "position": {
                  "x": 20.82,
                  "y": 119
              },
              "width": imagesSizes.plots[0].width,
              "height": imagesSizes.plots[0].height,
              "alignment": "left",
              "fontSize": 13,
              "characterSpacing": 0,
              "lineHeight": 1
            },
            "regression0": {
                "type": "image",
                "position": {
                    "x": 20.82,
                    "y": 247
                },
                "width": imagesSizes.regressions[0].width,
                "height": imagesSizes.regressions[0].height,
                "alignment": "left",
                "fontSize": 13,
                "characterSpacing": 0,
                "lineHeight": 1
            },
            "colorLegend0": {
              "type": "image",
              "position": {
                "x": 118.27,
                "y": 248.01
              },
              "width": imagesSizes.colorLegends[0].width,
              "height": imagesSizes.colorLegends[0].height,
              "alignment": "left",
              "fontSize": 13,
              "characterSpacing": 0,
              "lineHeight": 1
            },
            
        }
      let scenarioData = templateHandler.getScenarioDataStructure(scenario)
      let firstPage = projectData
      let secondPage = Object.assign(baseData, scenarioData)
      let nextPages = this.addPages(plotCount, imagesSizes)
      nextPages.unshift(secondPage)
      nextPages.unshift(firstPage)
      let template = {
        "schemas": nextPages,
        "basePdf": basePdf
      }
      return template
    },
    prepareInputs(scenario, data, images, plotNumber) {
      let today = new Date()
      let projectInputs = 
        {
          'summary': data.summary,
          'project_type': data.project_type,
          'study_phase': 'data.study_phase',
          'external_identifier': data.external_identifier,
          'primary_investigator': data.primary_investigator,
          'outcome': data.outcome,
          'description_long': data.description_long,
          'study_design': data.study_design,
          'elegibility_criteria': data.elegibility_criteria,
        }
      let baseInputs = [
        {
          "title": data.title,
          "organisation": data.organisation,
          "description": data.description,
          "date":`${today.getFullYear() + "/" + (today.getMonth()+1)+ "/" + today.getDate()}`,
          "plot0": images.plots[0],
          "regression0": images.regressions[0],
          "colorLegend0": images.colorLegends[0],
          "user": data.user
        }
      ]
      let projectInputOptions = Object.keys(projectInputs)
      projectInputOptions.forEach(option => baseInputs[0][option] = data[option])
      let scenarioInputOptions = Object.keys(templateHandler.getScenarioDataStructure(scenario))
      scenarioInputOptions.forEach(option => {
        baseInputs[0][option] = data[option]
      })
      if (plotNumber > 1) {
        for (let pNum=1; pNum < plotNumber; pNum++) {
          baseInputs[0][`plot${pNum}`] = images.plots[pNum]
          baseInputs[0][`regression${pNum}`] = images.regressions[pNum]
          baseInputs[0][`colorLegend${pNum}`] = images.colorLegends[pNum]
        }
      }
      return baseInputs
    },
    addPages(plotNumber, imagesSizes) {
      let nextPages = []
      if (plotNumber > 1) {
        let pageCount = Math.ceil(plotNumber/2)
        for (let p=1; p <= pageCount; p++) {
          let page = {}
          page[`plot${p}`] = {
            "type": "image",
            "position": {
                "x": 20.82,
                "y": 44
            },
            "width": imagesSizes.plots[p].width,
            "height": imagesSizes.plots[p].height,
            "alignment": "left",
            "fontSize": 13,
            "characterSpacing": 0,
            "lineHeight": 1
          },
          page[`regression${p}`] = {
            "type": "image",
            "position": {
                "x": 20.82,
                "y": 171
            },
            "width": imagesSizes.regressions[p].width,
            "height": imagesSizes.regressions[p].height,
            "alignment": "left",
            "fontSize": 13,
            "characterSpacing": 0,
            "lineHeight": 1
          },
          page[`colorLegend${p}`] = {
            "type": "image",
            "position": {
                "x": 118.27,
                "y": 171
            },
            "width": imagesSizes.colorLegends[p].width,
            "height": imagesSizes.colorLegends[p].height,
            "alignment": "left",
            "fontSize": 13,
            "characterSpacing": 0,
            "lineHeight": 1
          },
          nextPages.push(page)
        }
      } else {
        nextPages.push({})
      }
      return nextPages
    },
    processImages(images, plotNumber) {
      let pSizes = []
      let rSizes = []
      let clSizes = []
      for (let i = 0; i < plotNumber; i++) {
        pSizes[i] = this.resizeImage(images.pSizes[i], 168)
        rSizes[i] = this.resizeImage(images.rSizes[i], 70)
        clSizes[i] = this.resizeImage(images.colorLegendSizes[i], 70)
      }
      return {
        'plots': pSizes,
        'regressions': rSizes,
        'colorLegends': clSizes
      }
    },
    resizeImage(oldSize, newWidth) {
      let imageAspectRatio = oldSize[0]/oldSize[1]
      let imageHeight = newWidth/imageAspectRatio
      return {'width': newWidth, 'height': imageHeight}
    }
}

